import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { baseUrl } from '../utils/constants';

const initialCycle = {
  payCycleId: 0,
  processed: false,
  chequesDone: false,
  chequesPrinted: false,
  payDate: '',
  personalAccProc: false,
  selfPmts: false,
  selfPmtsJournals: false,
  rate: 0
};

const initialProvider = {
  provider_id: 0,
  provider: '',
  initials: '',
  title_id: 0,
  language_id: 0,
  add1: '',
  add2: '',
  add3: '',
  phone1: '',
  phone2: '',
  tariffs: '',
  namasNo: '',
  regNo: '',
  town_id: 0,
  paymentMethod_id: 0,
  bank_id: 0,
  bankAccount: '',
  discipline_id: 0,
  alliance_id: 0,
  drCode: '',
  branch_Id: 0,
  frequency: 0,
  user_id: 0,
  captureDate: '',
  // terminatedBy: 0,
  // termdate: '',
  status_id: 0,
  email: '',
  fax: '',
  recover: 0,
  max_authorized_amt: 0,
  copayment: 0,
  // copayAlertSent: false,
  // restricted: 0,
  currencyID: 0,
  glaccount: '',
  nextAuthorisation: 0,
  oldglaccount: '',
  cutOff: ''
};

const initialBenefit = {
  recorD_ID: 0,
  schemE_ID: '',
  membertypE_ID: '',
  servtypE_ID: '',
  depT_ID: '',
  cover: 100,
  coPayment: 0,
  threshHold: 0,
  atB_Cover: 0,
  atB_CoPayment: 0,
  limit: 0,
  limitDays: 365,
  waitingPeriod: 0,
  forceAuthorisation: false,
  ppn: false,
  tarrif: false,
  limitType_id: 3,
  startdate: '',
  enddate: null,
  user_id: 0,
  claimLimit: 0,
  terminateMember: false,
  benefitGender: 4,
  ageBased: '0',
  uploadbenefitReference: null,
  noOfVisits: 0
};

const initialTemplate = {
  templateId: 0,
  notificationType: 0,
  templateName: '',
  status: true,
  enterpriseFieldTypeKey: 0,
  enterpriseFieldName: '',
  reference: 0,
  messageBody: '',
  referenceName: null,
  useEntepriseType: false,
  notificationDeliveryTypeId: 1,
  category: 0,
  messageSubject: '',
  pushOverride: false,
  notificationsTypes: {
    lookupList: [],
    replyStatus: 0,
    replyMessage: '',
    uniqueIdentifier: null,
    transactionRef: 0
  },
  notificationCategories: null,
  enterpriseFieldTypes: {
    lookupList: [],
    replyStatus: 0,
    replyMessage: '',
    uniqueIdentifier: null,
    transactionRef: 0
  },
  notificationDeliveryTypes: {
    lookupList: [],
    replyStatus: 0,
    replyMessage: '',
    uniqueIdentifier: null,
    transactionRef: 0
  },
  childTemplates: {
    lookupList: [],
    replyStatus: 0,
    replyMessage: '',
    uniqueIdentifier: null,
    transactionRef: 0
  },
  parentRefId: null,
  parentTemplateName: null,
  includeHeader: false,
  includeFooter: false,
  replyStatus: 0,
  replyMessage: '',
  uniqueIdentifier: null,
  transactionRef: 0
};

const SettingContext = React.createContext();

export const SettingProvider = (props) => {
  const [moduleType, setModuleType] = useState(4);
  const [moduleName, setModuleName] = useState('Client');
  const [settingType, setSettingType] = useState(0);
  const [subsAmount, setSubsAmount] = useState(0);
  const [assureAmount, setAssureAmount] = useState(0);
  const [settingName, setSettingName] = useState('Other');
  const [currentCycleId, setCycleId] = useState(0);
  const [currentCycle, setCycle] = useState(initialCycle);
  const [doctor, setDoctor] = useState(initialProvider);
  const [providerId, setProviderId] = useState(-1);
  const [limitSetup, setLimitSetUp] = useState(initialBenefit);
  const [payCycles, setPayCycles] = useState([]);
  const [payCyclesSubs, setPayCyclesSubs] = useState([]);
  const [tariffList, setTariffList] = useState([]);
  const [currentTemplate, setCurrentTemplate] = useState(initialTemplate);

  useEffect(() => {
    getAllPayCycles();
    getAllPayCyclesSubs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    getModuleSetting('29', '19');
    getModuleSetting('29', '20');
  }, []);

  const initializeCycle = () => {
    setCycle(initialCycle);
  };

  const getCycle = async (cycleId) => {
    await axios(`${baseUrl}/api/setting/getAllPayCycles`).then(
      (result) => {
        console.log('returned cycle details info', result);
        // setCycle(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getAllPayCycles = async (cycleId) => {
    await axios(`${baseUrl}/api/setting/getAllPayCycles`).then(
      (result) => {
        console.log('returned cycle details info', result);
        setPayCycles(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getAllPayCyclesSubs = async (cycleId) => {
    await axios(`${baseUrl}/api/setting/getAllPayCyclesSubs`).then(
      (result) => {
        console.log('returned cycle details info', result);
        setPayCyclesSubs(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getModuleSetting = async (type, settingId) => {
    await axios(
      `${baseUrl}/api/setting/getModuleSetting?type=${type}&settingId=${settingId}&countryRefId=1`
    ).then(
      (result) => {
        if (settingId === '19') setSubsAmount(result.data);
        if (settingId === '20') setAssureAmount(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const clearProviders = () => {
    setProviderId(-1);
    setDoctor(initialProvider);
  };

  const clearLimits = () => {
    setLimitSetUp(initialBenefit);
  };

  return (
    <SettingContext.Provider
      value={{
        moduleType,
        setModuleType,
        moduleName,
        setModuleName,
        settingType,
        setSettingType,
        settingName,
        setSettingName,
        currentCycle,
        setCycle,
        getCycle,
        currentCycleId,
        setCycleId,
        initializeCycle,
        doctor,
        setDoctor,
        providerId,
        setProviderId,
        clearProviders,
        limitSetup,
        setLimitSetUp,
        clearLimits,
        payCycles,
        payCyclesSubs,
        tariffList,
        setTariffList,
        subsAmount,
        currentTemplate,
        setCurrentTemplate,
        assureAmount
      }}
    >
      {props.children}
    </SettingContext.Provider>
  );
};

export const useSettingContext = () => useContext(SettingContext);
